export const AdSDK = {
    IMA: 'ima',
    IMA_DAI: 'ima_dai',
    DAI_API: 'dai_api',
    NONE: undefined
};
